import { createSelector } from 'reselect';

const userSelector = state => state.user;

// ROUTES
export const getRoutes = createSelector(userSelector, state => state.routes);
export const routes = createSelector(userSelector, state => state.routes);

// CURRENT USER
export const getLoginStatus = createSelector(userSelector, state => state.loggedIn);
export const loginStatus = createSelector(userSelector, state => state.loggedIn);
export const getUser = createSelector(userSelector, state => state.user);
export const roles = createSelector(userSelector, state => state?.user?.roles?.map(role => role.name));
export const isEditorOrAdmin = createSelector(userSelector, state =>
  state?.user?.roles?.find(role => role.name === 'editor' || role.name === 'admin')
);
export const current = createSelector(userSelector, state => state.user);
const GOW_USER_GROUP_ID = 'd99a0af7-a674-45f3-8a01-59c1457c355b';
export const isGowUser = createSelector(current, user => user.userGroupId === GOW_USER_GROUP_ID);
export const loading = createSelector(userSelector, state => state.loading);
